import Vue from 'vue'
import { Share } from '@capacitor/share'
import log from '@/plugins/log'
import { platform, isNativeApp } from '@/plugins/native-app/capacitor'

// The share API isn't available in most web browsers so check support first.
// Very modern browser or native app
export const canShare = 'share' in window.navigator || isNativeApp

export const shareListing = async listing => {
  Vue.prototype.$analytics.addEvent({
    category: 'listing',
    action: 'Shared listing',
    label: platform
  })

  if (isNativeApp) {
    try {
      await Share.share({
        text: Vue.prototype.$listingTitle(listing),
        url: `${process.env.VUE_APP_SITE_URL}/view/listing/${listing.url}`,
        dialogTitle: 'Share listing'
      })
    } catch (error) {
      log.debug('Error sharing native listing', error)
    }
  } else {
    // Web share API
    window.navigator
      .share({
        title: 'Share listing',
        text: Vue.prototype.$listingTitle(listing),
        url: `${process.env.VUE_APP_SITE_URL}/view/listing/${listing.url}`
      })
      .catch(error => log.debug('Error sharing web listing', error))
  }
}
